module.exports = __webpack_public_path__ + "img/move.48248b66.svg";